import type { IconData } from '@stacksjs/iconify-core'

export const intellectual: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M39.313 20.286C39.197 10.719 31.323 3 21.628 3C11.859 3 3.94 10.835 3.94 20.5c0 5.725 2.78 10.808 7.075 14.001v7.163c0 1.294.837 2.425 2.11 2.658c1.749.32 4.583.678 8.503.678s6.753-.358 8.501-.678c1.274-.233 2.11-1.364 2.11-2.659v-3.225l2.8.346a3 3 0 0 0 3.358-2.725l.566-6.718c1.671-.404 2.903-.988 3.734-1.488c.827-.498.926-1.56.363-2.344z\"/><path d=\"M15.658 10.454c-4.665 2.693-6.753 8.133-5.402 13.096c.435 1.6 2.316 2.09 3.75 1.262l14.912-8.61c1.435-.828 1.95-2.701.782-3.878c-3.622-3.652-9.378-4.563-14.042-1.87\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default intellectual
